import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import { useState } from "react";
import { getBrands } from "@utils/call-api/brands-call";
import BrandsContainer from "@components/views/Brands/BrandsContainer";
import BrandGlossary from "@components/views/Brands/BrandGlossary";

const Brands = ({ initialBrands }) => {
  const [brands, setBrands] = useState(initialBrands);
  const [tag, setTag] = useState(null);

  async function fetchBrandsByTag(newTag) {
    setTag(newTag);
    const brandsRes = await getBrands(newTag);

    setBrands(brandsRes || []);
  }

  return (
    <div className="brands-wrapper">
      <div className="brands-wrapper-padding-x">
        <BrandsContainer />
      </div>
      <BrandGlossary
        brands={brands}
        tag={tag}
        setTag={fetchBrandsByTag}
      />
    </div>
  );
};

export async function getServerSideProps({ params: { locale } }) {
  const initialTag = null;
  const brands = await getBrands(initialTag);

  return {
    props: {
      initialBrands: brands || [],
      ...(await getMessagesForNamespaces(locale, ["common", "brands"])),
    },
  };
}

Brands.requireAuth = false;

export default Brands;
